module.exports = __webpack_public_path__ + "img/restaurant_bodyimage02.5756960a.jpg";